module.exports = __webpack_public_path__ + "static/img/celoscope-37.2682c77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-37.jpg
// module id = NQhS
// module chunks = 51